import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Col } from "react-bootstrap";
import "../style/sidebarmenu.css";

function SidebarNavigation() {
  const [showMenu, setShowMenu] = useState(false);

  const closeMenu = () => setShowMenu(false);

  const menuClass = ({ isActive }) =>
    `menu-link ${isActive ? "active" : ""}`;

  return (
    <>
      {/* Mobile Toggle */}
      <button
        type="button"
        className="menu-toggle d-lg-none"
        onClick={() => setShowMenu(true)}
        aria-label="Open menu"
      >
        <i className="bi bi-list"></i>
      </button>

      {/* Overlay */}
      {showMenu && (
        <div
          className="menu-overlay"
          onClick={closeMenu}
          aria-hidden="true"
        />
      )}

      {/* Sidebar Column */}
      <Col lg={2} md={3} className="sidebar-column">
        <aside className={`menu-sidebar ${showMenu ? "active" : ""}`}>

          {/* Mobile Header */}
          <div className="mobile-header d-lg-none">
            <div>
              <span className="mobile-menu-label">ACCOUNT</span>
              <h5>My Account</h5>
            </div>

            <button
              type="button"
              className="menu-close"
              onClick={closeMenu}
              aria-label="Close menu"
            >
              <i className="bi bi-x-lg"></i>
            </button>
          </div>

          {/* Desktop Header */}
          <div className="sidebar-heading">
            <div className="sidebar-heading-icon">
              <i className="bi bi-person-circle"></i>
            </div>

            <div>
              <span>ACCOUNT</span>
              <h6>My Account</h6>
            </div>
          </div>

          <p className="menu-title">ACCOUNT MENU</p>

          <ul className="profile-menu">

            {/* My Orders */}
            <li>
              <NavLink
                to="/account/orders"
                className={menuClass}
                onClick={closeMenu}
              >
                <span className="menu-icon orders-icon">
                  <i className="bi bi-box-seam"></i>
                </span>

                <span className="menu-text">
                  My Orders
                </span>

                <i className="bi bi-chevron-right menu-arrow"></i>
              </NavLink>
            </li>

            {/* Customers */}
            <li>
              <NavLink
                to="/account/customers"
                className={menuClass}
                onClick={closeMenu}
              >
                <span className="menu-icon customers-icon">
                  <i className="bi bi-people"></i>
                </span>

                <span className="menu-text">
                  Customers
                </span>

                <i className="bi bi-chevron-right menu-arrow"></i>
              </NavLink>
            </li>

            {/* Hold Order */}
            <li>
              <NavLink
                to="/account/holdorder"
                className={menuClass}
                onClick={closeMenu}
              >
                <span className="menu-icon hold-icon">
                  <i className="bi bi-hand-index-thumb"></i>
                </span>

                <span className="menu-text">
                  Hold Order
                </span>

                <i className="bi bi-chevron-right menu-arrow"></i>
              </NavLink>
            </li>

            {/* My Collection */}
            <li>
              <NavLink
                to="/account/mycollection"
                end
                className={menuClass}
                onClick={closeMenu}
              >
                <span className="menu-icon collection-icon">
                  <i className="bi bi-collection"></i>
                </span>

                <span className="menu-text">
                  My Collection
                </span>

                <i className="bi bi-chevron-right menu-arrow"></i>
              </NavLink>
            </li>

            {/* My Profile */}
            <li>
              <NavLink
                to="/account/profile"
                className={menuClass}
                onClick={closeMenu}
              >
                <span className="menu-icon profile-icon">
                  <i className="bi bi-person"></i>
                </span>

                <span className="menu-text">
                  My Profile
                </span>

                <i className="bi bi-chevron-right menu-arrow"></i>
              </NavLink>
            </li>

          </ul>
        </aside>
      </Col>
    </>
  );
}

export default SidebarNavigation;